import { Component, OnInit } from '@angular/core';
import { UserService } from '@app/services/user/user.service';
import { FormBuilder } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { SortService } from '@app/components/sorting/SortService';
import { PdfService } from '@app/services/pdf/pdf.service';
import { MenuItem } from 'primeng/api';
import { CSVDataService } from '@app/export/CSVDataService';
import { NavigationEnd, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-agedistribution',
  templateUrl: './agedistribution.component.html',
  styleUrls: ['./agedistribution.component.css']
})
export class AgedistributionComponent implements OnInit {
  agedata;
  antal = 0;
  years: number[] = [];
  /*  ageForm = this.fb.group({
      institutionId: [390, '']
    });*/

  valuelist: number[] = [];
  newvaluelist: number[][] = [];
  intervalidx: number[] = [];

  agedistributionform;
  

  districts;
  institutions;
  camps;
  selectedyears: number[] = [];
  yearlist: number[] = [];
  currentYear = new Date().getFullYear();
  currentDate = new Date();
  institutionname: string;
form;
  
  items: MenuItem[];
  showSpinner = false;
  // tslint:disable-next-line:max-line-length
  constructor(private userService: UserService, private router: Router, private datePipe: DatePipe, private fb: FormBuilder, private institutionService: InstitutionsService, private pdfService: PdfService) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
  }

  ngOnInit() {
    this.agedistributionform = this.fb.group({
      type: ['', ''],
      institution: ['', ''],
      year: ['', '']
    });
    
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      districts: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: ['', '']
    });
    let idx = 0;
    while (idx < 10) {
      this.intervalidx.push(idx++);
    }
    // this.populateListBoxes();
    // this.populateYearList();

    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    // tslint:disable-next-line:max-line-length
    let firstrow;
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'Åldersfördelning_' + datum;
    let json;

    let firstdatarow;
    let data: any[] = [];
    let varv = 1;


    let datarows = {};

    this.agedata.forEach(x => {
      firstdatarow = {
        col1: 'Intervall',
        col2: x.year
      };
      data.push(firstdatarow);

      x.distribution.forEach(d => {
        datarows = {
          col1: d.span,
          col2: d.value
        }
        data.push(datarows);
      });

      let totrows = {
        col1: 'Totalt',
        col2: x.noOfPersons,
      };
      data.push(totrows);

      let youngrows = {
        col1: 'Yngst',
        col2: x.youngest
      };
      data.push(youngrows);

      let oldrows = {
        col1: 'Äldst',
        col2: x.oldest
      };
      data.push(oldrows);

      let avgrows = {
        col1: 'Medel',
        col2: x.average
      };
      data.push(avgrows);

    });


    // data.push(datarows);


    let data2: any[] = [];
    let first;
    let col = 1;
    this.years.forEach(y => {
      if (col === 1) {
        first = {
          col1: 'Intervall',

        }
        col++;
        first['col' + col] = y;
      } else {
        first['col' + col] = y;
      }
      col++;
    });
    data2.push(first);
    let v = 1;

    data.forEach(d => {
      if ((v > 1 && v < 16)) {
        if (varv < 3) {
          let row = {
            col1: d.col1,
            col2: d.col2
          };
          data2.push(row);
        } else {
          data2[v-1]['col' + varv] = d.col2;
        }
      } else {
        v = 1;
        varv++;
      }
      v++;
    });

    const reportdate = this.datePipe.transform(this.currentDate, 'yyyy-MM-dd');
    if (this.institutionname) {
      firstrow = 'Åldersfördelningsrapport för ' + this.institutionname + '  ' + reportdate +  '\n';
    }
    if (this.form.get('lodges')?.value === 'b') {
      firstrow = 'Åldersfördelningsrapport totalt Bröder (loger)' + '  ' + reportdate + '\n';
    }
    if (this.form.get('lodges')?.value === 'r') {
      firstrow = 'Åldersfördelningsrapport totalt Systrar (loger)' + '  ' + reportdate + '\n';
    }
    if (this.form.get('camps')?.value === 'bl') {
      firstrow = 'Åldersfördelningsrapport totalt Bröder (läger)' + '  ' + reportdate + '\n';
    }
    if (this.form.get('camps')?.value === 'rl') {
      firstrow = 'Åldersfördelningsrapport totalt Systrar (läger)' + '  ' + reportdate + '\n';
    }
    CSVDataService.exportToCsv(filnamn + '.csv', data2, firstrow);

  }



  getAgeDistribution() {
    let subset;
    const type = this.agedistributionform.get('type').value;
    switch (type) {
      case 'B': subset = 1;
        break;
      case 'BL': subset = 1;
        break;
      case 'BD': subset = 1;
        break;
      case 'R': subset = 2;
        break;
      case 'RL': subset = 2;
        break;
      case 'RD': subset = 2;
        break;

    }
    const data = {
      institutionId: this.agedistributionform.get('institution').value,
      subset: subset,
      years: this.selectedyears
    };


    this.userService.getAgeDistribution(data).subscribe(response => {
      if (response) {
        this.valuelist = [];
        this.years = [];
        this.agedata = response;

        for (const a of this.agedata) {
          this.years.push(a.year);
        }
        this.antal = 200 + (this.years.length * 80);

        for (const a of this.agedata) {
          for (const d of a.distribution) {
            this.valuelist.push(d.value);
          }
        }

        let idx = 0;
        // let varv = this.years.length;
        let yearvalues: number[] = [];

        let varv = 0;
        for (const v of this.valuelist) {
          varv++;

          if (idx < 10) {
            yearvalues.push(v);
            idx++;
          } else {
            this.newvaluelist.push(yearvalues);
            yearvalues = [];
            idx = 0;
            yearvalues.push(v);
            idx++;
          }
        }
        if (varv === this.years.length * 10) {
          this.newvaluelist.push(yearvalues);
        }
      }
    });

  }

  createReport(evt) {
    this.showSpinner = true;

    if (evt.value.institutions?.length > 0) {
      this.institutionService.getInstitutionByIdAsync(evt.value.institutions[0]).subscribe(x => {
        if (x) {
          this.institutionname = x.shortName + ' ' + x.name;
        }
      });
    }

    if (evt.value.districts?.length > 0) {
      this.institutionService.getInstitutionByIdAsync(evt.value.districts[0]).subscribe(x => {

        if (x) {
          this.institutionname = x.shortName + ' ' + x.name;
        }
      });
    }
    const statisticsInput = {
      generalStatisticsReportInputModel: evt.value
    };

    this.userService.getAgeDistribution(statisticsInput).subscribe(response => {
      this.agedata = [];
      this.newvaluelist = [];
      if (response) {
        this.valuelist = [];
        this.years = [];
        this.agedata = response;

        for (const a of this.agedata) {
          this.years.push(a.year);
        }
        this.antal = 200 + (this.years.length * 80);

        for (const a of this.agedata) {
          for (const d of a.distribution) {
            this.valuelist.push(d.value);
          }
        }

        let idx = 0;
        // let varv = this.years.length;
        let yearvalues: number[] = [];

        let varv = 0;
        for (const v of this.valuelist) {
          varv++;

          if (idx < 10) {
            yearvalues.push(v);
            idx++;
          } else {
            this.newvaluelist.push(yearvalues);
            yearvalues = [];
            idx = 0;
            yearvalues.push(v);
            idx++;
          }
        }
        if (varv === this.years.length * 10) {
          this.newvaluelist.push(yearvalues);
        }
      }
      this.showSpinner = false;
    });

  }

  clearReport() {
    this.form?.reset();
    this.agedata = [];
    this.years = [];
  }

  populateListBoxes() {
    switch (this.agedistributionform.get('type').value) {
      case 'B': this.populateInstitutions(1);
        this.districts = [];
        this.camps = [];
        break;
      case 'R': this.populateInstitutions(2);
        this.districts = [];
        this.camps = [];
        break;
      case 'BD': this.populateDistricts(1);
        this.institutions = [];
        this.camps = [];
        break;
      case 'RD': this.populateDistricts(2);
        this.institutions = [];
        this.camps = [];
        break;
      case 'BL': this.populateCamps(1);
        this.institutions = [];
        this.districts = [];
        break;
      case 'RL': this.populateCamps(2);
        this.institutions = [];
        this.districts = [];
        break;
    }
  }

  populateDistricts(subset: number) {
    this.institutionService.GetAllDistrictsAsync(subset).subscribe(response => {
      if (response) {
        this.districts = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
      }
    });
  }

  populateInstitutions(subset: number) {
    this.institutionService.GetAllPrimaryLodgesAsync(subset).subscribe(response => {
      if (response) {
        this.institutions = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
      }
    });
  }

  populateCamps(subset: number) {
    this.institutionService.GetAllCampsAsync(subset).subscribe(response => {
      if (response) {
        this.camps = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
      }
    });
  }

  setDistrict(evt: any) {
    this.institutionService.GetInstitutionChildren(Number(evt.target.value)).subscribe(response => {
      if (response) {
        this.institutions = response;
      }
    });

    this.institutionname = evt.target.options[evt.target.options.selectedIndex].text;
  }

  setInstitution(evt: any) {

    this.institutionname = evt.target.options[evt.target.options.selectedIndex].text;
  }

  setCamp(evt: any) {
    this.institutionname = evt.target.options[evt.target.options.selectedIndex].text;
  }

  generateReport() {
    this.getAgeDistribution();
  }

  populateYearList() {
    while (this.currentYear >= 1884) {
      this.yearlist.push(this.currentYear--);
    }
  }

  addYear() {
    if (this.selectedyears.indexOf(+this.agedistributionform.get('year').value) === -1) {
      this.selectedyears.push(+this.agedistributionform.get('year').value);
      this.sortSelectedYears();
    }
  }

  unselectYear(year: number) {
    const idx = this.selectedyears.findIndex(element => element === year);
    this.selectedyears.splice(idx, 1);
  }

  sortSelectedYears() {
    this.selectedyears = this.selectedyears.sort((a, b) => {
      return SortService.cmpStringsWithNumbers(a, b, true);
    });
  }

  clear() {
    this.agedistributionform?.reset();
    this.agedata = [];
    this.selectedyears = [];
    this.districts = [];
    this.institutions = [];
    this.camps = [];
    this.years = [];
    this.populateYearList();

  }

  createPdf() {
    const data = document.getElementById('contentToConvert');
    this.pdfService.captureScreen(data, 'l',null);
  }
}
